import { CommonModule, CurrencyPipe } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { AccordionModule } from "primeng/accordion";
import { DialogService } from "primeng/dynamicdialog";
import { MenuModule } from "primeng/menu";
import { PopoverModule } from "primeng/popover";
import { TableModule } from "primeng/table";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { AccessManagementComponent } from "./components/rn-business-components/access-management/access-management.component";
import { AddUserComponent } from "./components/rn-business-components/add-user/add-user.component";
import { ApplicationCardComponent } from "./components/rn-business-components/application-card/application-card.component";
import { BillingFormComponent } from "./components/rn-business-components/billing-form/billing-form.component";
import { BillingSeparationComponent } from "./components/rn-business-components/billing-separation/billing-separation.component";
import { BusinessAddressComponent } from "./components/rn-business-components/business-address/business-address.component";
import { CardListComponent } from "./components/rn-business-components/card-list/card-list.component";
import { ChangePackageComponent } from "./components/rn-business-components/change-package/change-package.component";
import { CopyActivationComponent } from "./components/rn-business-components/copy-activation/copy-activation.component";
import { DeployQuickbooksComponent } from "./components/rn-business-components/deploy-quickbooks/deploy-quickbooks.component";
import { DetailedBillingReportsComponent } from "./components/rn-business-components/detailed-billing-reports/detailed-billing-reports.component";
import { DownloadSetupWizardComponent } from "./components/rn-business-components/download-setup-wizard/download-setup-wizard.component";
import { EstimatedBillBreakdownComponent } from "./components/rn-business-components/estimated-bill-breakdown/estimated-bill-breakdown.component";
import { EventsComponent } from "./components/rn-business-components/events/events.component";
import { InvoicesComponent } from "./components/rn-business-components/invoices/invoices.component";
import { MaintenanceModeNotificationComponent } from "./components/rn-business-components/maintenance-mode-notification/maintenance-mode-notification.component";
import { ManageAddonsComponent } from "./components/rn-business-components/manage-addons/manage-addons.component";
import { NewUserDetailsComponent } from "./components/rn-business-components/new-user-details/new-user-details.component";
import { OrganizationAddressComponent } from "./components/rn-business-components/organization-address/organization-address.component";
import { OrganizationChangeStatusComponent } from "./components/rn-business-components/organization-change-status/organization-change-status.component";
import { OrganizationInfoCreateComponent } from "./components/rn-business-components/organization-info-create/organization-info-create.component";
import { PaymentFormAchComponent } from "./components/rn-business-components/payment-form-ach/payment-form-ach.component";
import { PaymentFormCcComponent } from "./components/rn-business-components/payment-form-cc/payment-form-cc.component";
import { PrimaryFrameComponent } from "./components/rn-business-components/primary-frame/primary-frame.component";
import { OrgRenameUserLoggedInDialogComponent } from "./components/rn-business-components/rename-error/rename-error.component";
import { ReviewUserComponent } from "./components/rn-business-components/review-user/review-user.component";
import { SearchControlComponent } from "./components/rn-business-components/search-control/search-control.component";
import { RnFooterComponent } from "./components/rn-business-components/sidebar/rn-footer/rn-footer.component";
import { RnHeaderComponent } from "./components/rn-business-components/sidebar/rn-header/rn-header.component";
import { RnNavigationBarComponent } from "./components/rn-business-components/sidebar/rn-navigation-bar/rn-navigation-bar.component";
import { RnSidebarComponent } from "./components/rn-business-components/sidebar/rn-sidebar/rn-sidebar.component";
import { UserActionDialogComponent } from "./components/rn-business-components/user-action-dialog/user-action-dialog.component";
import { ChangeOrganizationFolderDialogComponent } from "./components/rn-business-components/change-organization-folder-dialog/change-organization-folder-dialog.component";
import { CloseOrganizationDialogComponent } from "./components/rn-business-components/close-organization-dialog/close-organization-dialog.component";
import { UserKeepDropPackageDialogComponent } from "./components/rn-business-components/user-keep-drop-package-dialog/user-keep-drop-package-dialog.component";
import { GridComponent } from "./components/third-party-wrappers/grid/grid.component";
import { ProcessButtonComponent } from "./components/third-party-wrappers/process-button/process-button.component";
import { ButtonComponent } from "./components/third-party-wrappers/button/button.component";
import { IdleDialogComponent } from "./idle/dialog/idle-dialog.component";
import { UtcToLocalDatePipe } from "./pipes/utcToLocalDate/utc-to-local-date.pipe";
import { AuthResponseInteceptor } from "./security/auth-response-inteceptor";
import { AuthGuardService } from "./security/auth.guard.service";
import { AuthenticationService } from "./security/authentication.service";
import { NotAuthorizedComponent } from "./security/not-authorized/not-authorized.component";
import { AddressService } from "./services/address/address.service";
import { RnDialogService } from "./services/dialog/rndialog.service";
import { LoggedInInfoService } from "./services/loggedInInfo/logged-in-info.service";
import { RnErrorHandlerService } from "./services/rn-error-handler/rn-error-handler.service";
import { PackageInventoryComponent } from "./components/rn-business-components/package-inventory/package-inventory.component";
import { DirectInventoryTableComponent } from "./components/rn-business-components/package-inventory/direct-inventory-table/direct-inventory-table.component";
import { WlpInventoryTableComponent } from "./components/rn-business-components/package-inventory/wlp-inventory-table/wlp-inventory-table.component";
import { ChangePackageInventoryComponent } from "./components/rn-business-components/change-package-inventory/change-package-inventory.component";
import { PackageCardComponent } from "./components/rn-business-components/package-card/package-card.component";
import { QuantityControlComponent } from "./components/third-party-wrappers/quantity-control/quantity-control.component";
import { PackageManagementComponent } from "./components/rn-business-components/package-management/package-management.component";
import { PackageAssignmentComponent } from "./components/rn-business-components/package-assignment/package-assignment.component";
import { MatDialogModule } from "@angular/material/dialog";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { NotificationDialogService } from "./services/notificationDialog/notification-dialog.service";
import { NotificationDialogComponent } from "./services/notificationDialog/notification-dialog/notification-dialog.component";
import { MatMenuModule } from "@angular/material/menu";
import { MatDividerModule } from "@angular/material/divider";
import { ShoppingCartComponent } from "./components/rn-business-components/shopping-cart/shopping-cart.component";
import { ShoppingCartIconComponent } from "./components/rn-business-components/shopping-cart-icon/shopping-cart-icon.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LookupStoreService } from "./services/lookup-store/lookup-store.service";
import { UserUpdatePinComponent } from "./components/rn-business-components/user-update-pin/user-update-pin.component";
import { UserUpdateProfileComponent } from "./components/rn-business-components/user-update-profile/user-update-profile.component";
import { LicenseManagementComponent } from "./components/rn-business-components/license-management/license-management.component";
import { LicenseAddEditComponent } from "./components/rn-business-components/license-add-edit/license-add-edit.component";
import { UsersManagementComponent } from "./components/rn-business-components/users-management/users-management.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatRippleModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { CreateRenameFolderComponent } from "./components/rn-business-components/create-rename-folder/create-rename-folder.component";
import { DeleteFldrConfirmComponent } from "./components/rn-business-components/delete-fldr-confirm/delete-fldr-confirm.component";
import { RightSideBarComponent } from "./components/rn-business-components/sidebar/rn-right-sidebar/rn-right-sidebar.component";
import { DrawerModule } from "primeng/drawer";
import { RnsidebarService } from "./services/sidebar/rnsidebar.service";
import { ManageAddonsSidebarComponent } from "./components/rn-business-components/manage-addons-sidebar/manage-addons-sidebar.component";
import { OrgRenameUserLoggedInDialogNotificationComponent } from "./services/notificationDialog/rename-error/rename-error.component";
import { ManagePackagesSidebarComponent } from "./components/rn-business-components/manage-packages-sidebar/manage-packages-sidebar.component";
import { DateRangePickerComponent } from "./components/third-party-wrappers/date-range-picker/date-range-picker.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { CdkTreeModule } from "@angular/cdk/tree";
import { RnConfirmationComponent } from "./components/rn-business-components/sidebar/rn-confirmation/rn-confirmation.component";
import { LicenseDetailsComponent } from "./components/rn-business-components/license-details/license-details.component";
import { EscapeCharacterPipe } from "./pipes/escapeCharacter/escape-character.pipe";
import { LicenseAssignComponent } from "./components/rn-business-components/license-assign/license-assign.component";
import { MessageModule } from "primeng/message";
import { EmailVerficationComponent } from "./components/rn-business-components/email-verfication/email-verfication.component";
import { IconComponent } from "./components/rn-business-components/icon/icon.component";
import { LoaderComponent } from "./components/third-party-wrappers/loader/loader.component";
import { SalesforceChatComponent } from "./components/third-party-wrappers/salesforce-chat/salesforce-chat.component";
import { GenericDialogComponent } from "./components/rn-business-components/generic-dialog/generic-dialog.component";
import { SwitchComponent } from "./components/third-party-wrappers/switch/switch.component";
import { LabelComponent } from "./components/third-party-wrappers/label/label.component";
import { PromoCodeComponent } from "./components/rn-business-components/promo-code/promo-code.component";
import { ListFormatPipe } from "./pipes/listFormat/list-format.pipe";
import { RnGridPipe } from "./pipes/rnGrid/rn-grid.pipe";
import { RnFormatLowercaseNoSpacePipe } from "./pipes/rnFormatLowercaseNoSpace/rn-format-lowercase-no-space";
import { TrimInputDirective } from "./directives/trim-input.directive";
import { HttpErrorInterceptor } from "./interceptors/http-error.interceptor";
import { MatTreeModule } from "@angular/material/tree";
import { A11yModule } from "@angular/cdk/a11y";
import { BidiModule } from "@angular/cdk/bidi";
import { ObserversModule } from "@angular/cdk/observers";
import { OverlayModule } from "@angular/cdk/overlay";
import { PlatformModule } from "@angular/cdk/platform";
import { PortalModule } from "@angular/cdk/portal";
import { CdkStepperModule } from "@angular/cdk/stepper";
import { CdkTableModule } from "@angular/cdk/table";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatBadgeModule } from "@angular/material/badge";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { FilterPipe } from "./components/third-party-wrappers/filer-pipe/filer-pipe.component";
import { AccessManagementAssignComponent } from "./components/rn-business-components/access-management-assign/access-management-assign.component";
import { QboSubscriptionManagementComponent } from "./components/rn-business-components/license-management/qbo-subscription-management/qbo-subscription-management.component";
import { CustomMatPaginatorIntl } from "./components/third-party-wrappers/mat-paginator-control/custom-mat-paginator-intl";
import { LocalAppCardComponent } from "./components/rn-business-components/local-app-card/local-app-card.component";
import { QboPlansComponent } from "./components/rn-business-components/license-management/qbo-purchase/qbo-plans/qbo-plans.component";
import { QboPayrollComponent } from "./components/rn-business-components/license-management/qbo-purchase/app-qbo-payroll/qbo-payroll.component";
import { QboTimeComponent } from "./components/rn-business-components/license-management/qbo-purchase/qbo-time/qbo-time.component";
import { QboCheckoutComponent } from "./components/rn-business-components/license-management/qbo-purchase/qbo-checkout/qbo-checkout.component";
import { QboConfirmationComponent } from "./components/rn-business-components/license-management/qbo-purchase/qbo-confirmation/qbo-confirmation.component";
import { LicenseEditComponent } from "./components/rn-business-components/license-edit/license-edit.component";
import { UiCommonModule } from "@rn-platform/frontend-shared-ui-common";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { UserDetailsModalComponent } from "./components/rn-business-components/sidebar/user-details-modal/user-details-modal.component";
import { InstallableAppComponent } from "./components/rn-business-components/installable-app/installable-app.component";
import { AzureCredentialsComponent } from "./components/rn-business-components/azure-credentials/azure-credentials.component";
import { PaginatorComponent } from "./components/rn-business-components/paginator/paginator.component";
import { DatePickerComponent as UiCommonDatePickerComponent } from "@rn-platform/frontend-shared-ui-common";
import { AiChatButtonComponent } from "./components/rn-business-components/sidebar/ai-chat-button/ai-chat-button.component";
import { UserPackageChangeComponent } from "./components/rn-business-components/user-package-change/user-package-change.component";
import { UserPackageChangeOptionsComponent } from "./components/rn-business-components/user-package-change-options/user-package-change-options.component";
import { ConfirmationModalComponent } from "./components/rn-business-components/confirmation-modal/confirmation-modal.component";
import { QboSubscriptionComponent } from "./components/rn-business-components/license-management/qbo-purchase/qbo-subscription-modal/qbo-subscription.component";
import { QboPurchaseComponent } from "./components/rn-business-components/license-management/qbo-purchase/qbo-purchase.component";
import { PaymentFormComponent } from "./components/rn-business-components/payment-form/payment-form.component";
import { ScriptLoaderService } from "./services/script-loader/script-loader.service";
import { LegacyUserDetailsModalComponent } from "./components/rn-business-components/sidebar/legacy-user-details-modal/legacy-user-details-modal.component";
import { PaymentTypePipe } from "./pipes/payment-type/payment-type.pipe";
import { WjGridModule } from '@mescius/wijmo.angular2.grid'
import { UiWijmoModule } from '@rn-platform/frontend-shared-ui-wijmo';

@NgModule({
  declarations: [
    NotAuthorizedComponent,
    IdleDialogComponent,
    GridComponent,
    SearchControlComponent,
    RnHeaderComponent,
    RnFooterComponent,
    RnSidebarComponent,
    RnNavigationBarComponent,
    DownloadSetupWizardComponent,
    OrganizationAddressComponent,
    OrganizationInfoCreateComponent,
    ProcessButtonComponent,
    ButtonComponent,
    CopyActivationComponent,
    AccessManagementComponent,
    ChangePackageComponent,
    ManageAddonsComponent,
    UserActionDialogComponent,
    ChangeOrganizationFolderDialogComponent,
    CloseOrganizationDialogComponent,
    UserKeepDropPackageDialogComponent,
    AddUserComponent,
    NewUserDetailsComponent,
    DeployQuickbooksComponent,
    ReviewUserComponent,
    OrganizationChangeStatusComponent,
    ApplicationCardComponent,
    CardListComponent,
    PrimaryFrameComponent,
    MaintenanceModeNotificationComponent,
    UtcToLocalDatePipe,
    BillingFormComponent,
    BillingSeparationComponent,
    PaymentFormAchComponent,
    PaymentFormCcComponent,
    BusinessAddressComponent,
    EventsComponent,
    OrgRenameUserLoggedInDialogComponent,
    EstimatedBillBreakdownComponent,
    InvoicesComponent,
    DetailedBillingReportsComponent,
    PackageInventoryComponent,
    DirectInventoryTableComponent,
    WlpInventoryTableComponent,
    ChangePackageInventoryComponent,
    PackageCardComponent,
    QuantityControlComponent,
    PackageManagementComponent,
    PackageAssignmentComponent,
    NotificationDialogComponent,
    ShoppingCartComponent,
    ShoppingCartIconComponent,
    UserUpdateProfileComponent,
    UserUpdatePinComponent,
    LicenseManagementComponent,
    LicenseAddEditComponent,
    UsersManagementComponent,
    RightSideBarComponent,
    CreateRenameFolderComponent,
    DeleteFldrConfirmComponent,
    ManageAddonsSidebarComponent,
    OrgRenameUserLoggedInDialogNotificationComponent,
    ManagePackagesSidebarComponent,
    DateRangePickerComponent,
    RnConfirmationComponent,
    LicenseDetailsComponent,
    EscapeCharacterPipe,
    LicenseAssignComponent,
    AccessManagementAssignComponent,
    EmailVerficationComponent,
    IconComponent,
    LoaderComponent,
    SalesforceChatComponent,
    GenericDialogComponent,
    SwitchComponent,
    LabelComponent,
    PromoCodeComponent,
    ListFormatPipe,
    PromoCodeComponent,
    RnGridPipe,
    RnFormatLowercaseNoSpacePipe,
    TrimInputDirective,
    FilterPipe,
    QboSubscriptionManagementComponent,
    LocalAppCardComponent,
    QboSubscriptionComponent,
    QboPurchaseComponent,
    QboPlansComponent,
    QboPayrollComponent,
    QboTimeComponent,
    QboCheckoutComponent,
    QboConfirmationComponent,
    LicenseEditComponent,
    UserDetailsModalComponent,
    LegacyUserDetailsModalComponent,
    InstallableAppComponent,
    AzureCredentialsComponent,
    PaginatorComponent,
    AiChatButtonComponent,
    UserPackageChangeComponent,
    UserPackageChangeOptionsComponent,
    ConfirmationModalComponent,
    PaymentFormComponent,
    PaymentTypePipe
  ],
  imports: [
    CommonModule,
    TableModule,
    PopoverModule,
    FormsModule,
    MenuModule,
    TooltipModule,
    TreeModule,
    ReactiveFormsModule,
    MessageModule,
    MatCardModule,
    AccordionModule,
    MatDialogModule,
    MatMenuModule,
    MatDividerModule,
    MatTooltipModule,
    MatAutocompleteModule,
    DrawerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatTreeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatPaginatorModule,
    MatSortModule,
    MatBadgeModule,
    MatBottomSheetModule,
    UiCommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    UiCommonDatePickerComponent,
    WjGridModule,
    UiWijmoModule,
  ],
  exports: [
    GridComponent,
    SearchControlComponent,
    RnHeaderComponent,
    RnFooterComponent,
    RnSidebarComponent,
    OrganizationAddressComponent,
    ProcessButtonComponent,
    ButtonComponent,
    ApplicationCardComponent,
    CardListComponent,
    PrimaryFrameComponent,
    UtcToLocalDatePipe,
    EventsComponent,
    EstimatedBillBreakdownComponent,
    InvoicesComponent,
    DetailedBillingReportsComponent,
    PackageInventoryComponent,
    DirectInventoryTableComponent,
    WlpInventoryTableComponent,
    ChangePackageInventoryComponent,
    PackageManagementComponent,
    UserUpdateProfileComponent,
    UserUpdatePinComponent,
    LicenseManagementComponent,
    MatCardModule,
    PopoverModule,
    ShoppingCartIconComponent,
    ShoppingCartComponent,
    AddUserComponent,
    ShoppingCartComponent,
    ChangePackageComponent,
    ManageAddonsComponent,
    DeployQuickbooksComponent,
    UsersManagementComponent,
    MessageModule,
    DrawerModule,
    RightSideBarComponent,
    LicenseDetailsComponent,
    LicenseAssignComponent,
    RnConfirmationComponent,
    EscapeCharacterPipe,
    EmailVerficationComponent,
    LoaderComponent,
    IconComponent,
    SalesforceChatComponent,
    SwitchComponent,
    ListFormatPipe,
    SwitchComponent,
    RnGridPipe,
    RnFormatLowercaseNoSpacePipe,
    TrimInputDirective,
    CdkTreeModule,
    MatTreeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSnackBarModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    UiCommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    A11yModule,
    BidiModule,
    ObserversModule,
    OverlayModule,
    PlatformModule,
    PortalModule,
    CdkStepperModule,
    CdkTableModule,
    MaintenanceModeNotificationComponent,
    CopyActivationComponent,
    AccessManagementComponent,
    LicenseEditComponent,
    UserActionDialogComponent,
    ChangeOrganizationFolderDialogComponent,
    CloseOrganizationDialogComponent,
    UserKeepDropPackageDialogComponent,
    OrganizationInfoCreateComponent,
    BillingSeparationComponent,
    ManagePackagesSidebarComponent,
    OrgRenameUserLoggedInDialogComponent,
    CreateRenameFolderComponent,
    AzureCredentialsComponent,
    BillingFormComponent,
    PackageAssignmentComponent,
    LicenseAddEditComponent,
    AddUserComponent,
    UserPackageChangeComponent,
    UserPackageChangeOptionsComponent,
    ConfirmationModalComponent,
    QboSubscriptionComponent,
    PaymentFormComponent,
    UserDetailsModalComponent,
    PaymentTypePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        AuthenticationService,
        AuthGuardService,
        DialogService,
        RnDialogService,
        RnsidebarService,
        LoggedInInfoService,
        AddressService,
        RnErrorHandlerService,
        NotificationDialogService,
        LookupStoreService,
        ScriptLoaderService,
        CurrencyPipe,
        {
          provide: MatPaginatorIntl,
          useClass: CustomMatPaginatorIntl
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthResponseInteceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpErrorInterceptor,
          multi: true
        },
        {
          provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
          useValue: { appearance: "standard" }
        },
        MatDatepickerModule,
        MatNativeDateModule,
        EscapeCharacterPipe,
        provideNgxMask({ validation: false })
      ]
    };
  }
}
